import React from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Formik, Form } from 'formik';
import { withLocalize } from 'react-localize-redux';
import { bindActionCreators } from 'redux';
import { searchActions } from '../../../../store/searchStore';
import { isNullOrUndefined } from '../../../../store/storeFunctions';
import { getParams } from '../../../common/utils';
import { propertySkSearchBy } from '../../../../store/searchStore';
import { string as YupString, object as YupObject, date as YupDate } from '../../../common/Yup';
import BbInput from '../../../styling/bbInput';
import BbDatePicker from '../../../common/datePicker';
import BbRadioWrapper from '../../../styling/BbRadioWrapper';
import PropertySkFormButtons from './propertySkFormButtons';
import PropertySkSearchParamsErrorMessage from './propertySkSearchParamsErrorMessage';

const SUBJECT_TYPES = {
    company: "company",
    naturalPerson: "naturalPerson"
};

const KEYS = {
    subjectType: "subjectType",
    owner: "owner",
    companyId: "companyId",
    birthDate: "birthDate",
    name: "name",
    surname: "surname"
};

class PropertySkOwnerSearchForm extends React.Component {
    state = {
        subjectType: SUBJECT_TYPES.company
    };

    render() {
        const data = getParams(window.location.search);
        if ((!isNullOrUndefined(data) && !isNullOrUndefined(data.name)) && this.state.subjectType !== SUBJECT_TYPES.naturalPerson)
            this.setState({ subjectType: SUBJECT_TYPES.naturalPerson });
        return (
            <Formik
                ref={(el) => this.formRef = el}
                enableReinitialize={true}
                validationSchema={this.createValidationSchema()}
                validateOnChange={false}
                validateOnBlur={false}
                initialValues={{
                    [KEYS.subjectType]: SUBJECT_TYPES.company,
                    [KEYS.owner]: (!isNullOrUndefined(data) && !isNullOrUndefined(data.name)) ? data.name : "",
                    [KEYS.name]: (!isNullOrUndefined(data) && !isNullOrUndefined(data.name)) ? data.name : "",
                    [KEYS.surname]: (!isNullOrUndefined(data) && !isNullOrUndefined(data.surname)) ? data.surname : "",
                    [KEYS.companyId]: "",
                    [KEYS.birthDate]: (!isNullOrUndefined(data) && !isNullOrUndefined(data.birthDate)) ? data.birthDate : ""
                }}
                onSubmit={(values, { setSubmitting }) => {
                    if (this.state.subjectType === SUBJECT_TYPES.naturalPerson && document.getElementById('fo_dob').classList.contains('is-danger'))
                        return false;
                    setSubmitting(false);
                    values[KEYS.companyId] = values[KEYS.companyId].replace(/\s/g, '');
                    const query = [
                        `searchBy=${(this.state.subjectType === SUBJECT_TYPES.company ? propertySkSearchBy.companyOwners : propertySkSearchBy.personOwners)}`,
                        ...(Object.keys(values)
                            .map(k => isNullOrUndefined(values[k]) || values[k] === "" || k === KEYS.subjectType ? null : `${k}=${encodeURIComponent(values[k])}`)
                            .filter(f => !isNullOrUndefined(f)))
                    ];
                    this.props.history.push(`/search/property-sk/results${(query.length > 0 ? "?" + query.join("&") : "")}`);
                }}>
                {({ values, setFieldValue, errors }) => (
                    <Form>
                        {Object.keys(errors).length > 0 && <div className="column" style={{ marginBottom: "0.5em" }}>
                            <PropertySkSearchParamsErrorMessage errors={Object.keys(errors)} />
                        </div>}
                        <div className="columns">
                            <div className="bb-radio-group-wrapper">
                                <div className="bb-radio-group-row">
                                    <div className="control">
                                        <BbRadioWrapper
                                            id="radio-company"
                                            name={SUBJECT_TYPES.company}
                                            value={SUBJECT_TYPES.company}
                                            checked={this.state.subjectType === SUBJECT_TYPES.company}
                                            callback={(_) => this.subjectTypeChanged(SUBJECT_TYPES.company, setFieldValue)}
                                            label={this.props.translate("PropertySk.Search.Company")}
                                        />
                                    </div>
                                    <div className="control">
                                        <BbRadioWrapper
                                            id="radio-natural-person"
                                            name={SUBJECT_TYPES.naturalPerson}
                                            value={SUBJECT_TYPES.naturalPerson}
                                            checked={this.state.subjectType === SUBJECT_TYPES.naturalPerson}
                                            callback={(_) => this.subjectTypeChanged(SUBJECT_TYPES.naturalPerson, setFieldValue)}
                                            label={this.props.translate("PropertySk.Search.NaturalPerson")}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        {this.state.subjectType === SUBJECT_TYPES.company && <div>
                            <BbInput label={this.props.translate("PropertySk.Search.Owner")} name={KEYS.owner} type="text" placeholder={{ type: 'column' }} />
                            <BbInput label={this.props.translate("PropertySk.Search.CompanyId")} name={KEYS.companyId} type="text"
                                placeholder={{ type: 'column' }} disabled={this.state.subjectType !== SUBJECT_TYPES.company} />
                        </div>}
                        {this.state.subjectType === SUBJECT_TYPES.naturalPerson && <div>
                            <BbInput label={this.props.translate("PropertySk.Search.Name")} name={KEYS.name} type="text" placeholder={{ type: 'column' }} />
                            <BbInput label={this.props.translate("PropertySk.Search.Surname")} name={KEYS.surname} type="text" placeholder={{ type: 'column' }} />
                            <BbInput type='custom' label={this.props.translate('PropertySk.Search.BirthDate')} placeholder={{ type: 'column' }}
                                name={KEYS.birthDate}
                                custom={<BbDatePicker formik={this.formRef} field={KEYS.birthDate} value={values.birthDate}
                                    yearsBack={120} id="fo_dob"
                                    disabled={this.state.subjectType !== SUBJECT_TYPES.naturalPerson} formDateFormat={"YYYY-MM-DD"}
                                />}
                            />
                        </div>}
                        <PropertySkFormButtons isDisabled={this.state.subjectType === SUBJECT_TYPES.naturalPerson && (values.name == '' || values.surname == '')} />
                    </Form>
                )}
            </Formik>
        );
    }

    subjectTypeChanged = (value, setFieldValue) => {
        this.setState({ subjectType: value });
        setFieldValue(KEYS.subjectType, value);
    }

    createValidationSchema = () => {
        const wrongInputMsg = this.props.translate("Search.Common.Validation.WrongInput");

        const schemaCompany = YupObject().shape({
            [KEYS.owner]: YupString().when(KEYS.companyId, { is: (x) => isNullOrUndefined(x) || x === "", then: YupString().required(wrongInputMsg) }),
            [KEYS.companyId]: YupString().when(KEYS.owner, { is: (x) => isNullOrUndefined(x) || x === "", then: YupString().required(wrongInputMsg) })
        }, [KEYS.owner, KEYS.companyId]);

        const schemaNaturalPerson = YupObject().shape({
            [KEYS.name]: YupString().trim().required(wrongInputMsg),
            [KEYS.surname]: YupString().trim().required(wrongInputMsg),
            [KEYS.birthDate]: YupDate().min('1800-01-01').max(new Date())
        }, [KEYS.name, KEYS.surname, KEYS.birthDate]);

        return this.state.subjectType === SUBJECT_TYPES.company ? schemaCompany : schemaNaturalPerson;
    }
}

export default withRouter(withLocalize(connect(
    state => ({ ...state }),
    dispatch => bindActionCreators(searchActions, dispatch),
)(PropertySkOwnerSearchForm)));